import { render } from "./App.vue?vue&type=template&id=3c998fa0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3c998fa0&lang=css"
script.render = render

export default script